import React, { useState } from "react";
import Categories from "./Categories";
const Badge = () => {
  const [canUpdate, setCanUpdate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);

  return (
    <div className="page-top-div">
      <span className="text-span">Badge Manager</span>
      <Categories canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default Badge;
